module.exports = __webpack_public_path__ + "static/media/066.0db67a57.jpg";